const PARAGRAPH_SHARE = (uuid: string, paragraphName = false, page = 0, filter = "") => `
  ${paragraphName ? `${paragraphName}: ` : ""} paragraphsDataUUID(uuid: "${uuid}", page: ${Math.max(
	0,
	page,
)}, filter: "${filter}") {
    ... on Share {
      id
      type
      uuid
      totalPages     
    }
  }
`;

export default PARAGRAPH_SHARE;
